import { render } from "./AppRadioButton.vue?vue&type=template&id=2c6fea4b&scoped=true&ts=true"
import script from "./AppRadioButton.vue?vue&type=script&lang=ts"
export * from "./AppRadioButton.vue?vue&type=script&lang=ts"

import "./AppRadioButton.vue?vue&type=style&index=0&id=2c6fea4b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6fea4b"]])

export default __exports__